import {Divider} from '@mui/material';
import React from 'react';

import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';
import {
	OdontoAddressSection,
	OdontoHeaderSection,
	OdontoInformationSection,
	OdontoPhonesSection,
	OdontoProviderDataSection,
	OdontoServicesSection,
} from './components';
import {OdontoGuideDetailsProps} from './types';

const {close} = translations['pt-br'].commons;
const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;

export function OdontoGuideDetails({open, setOpen, provider}: OdontoGuideDetailsProps) {
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Drawer.Root
			open={open}
			onOpen={() => null}
			customMaxHeight="85%"
			width="420px"
			onClose={handleClose}>
			<Drawer.Header title={guideDetails.headerTitle} onClose={handleClose} />

			{provider ? (
				<Drawer.Content sx={{gap: 2}}>
					<OdontoHeaderSection provider={provider} onClose={handleClose} />
					<Divider />
					<OdontoProviderDataSection provider={provider} />
					<Divider />
					<OdontoPhonesSection provider={provider} />
					<Divider />
					<OdontoAddressSection provider={provider} />
					<OdontoInformationSection provider={provider} />
					<Divider />
					<OdontoServicesSection provider={provider} />
				</Drawer.Content>
			) : null}
			<Drawer.Footer
				firstButtonTitle={close}
				firstButtonOnClick={handleClose}
				hideSecondButton
			/>
		</Drawer.Root>
	);
}
